import { createAsyncThunk } from "@reduxjs/toolkit";
import { assignMachineToLocation } from "data/server_apis/vendingServices";

export const machineAssignmentToLocationState = {
  machineAssignmentLocationLoading: {},
  machineAssignmentLocationError: {},
  machineAssignmentLocationSuccess: {},
  machineAssignmentLocationErrorMessage: {},
};

export const machineAssignmentToLocationThunk = createAsyncThunk(
  "vending/assignMachineToLocation",
  async (data, { rejectWithValue }) => {
    try {
      return (await assignMachineToLocation(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const machineAssignmentToLocationBuilder = (builder) => {
  builder
    .addCase(machineAssignmentToLocationThunk.pending, (state, action) => {
      state.machineAssignmentLocationLoading[action.meta.arg.location] = true;
      state.machineAssignmentLocationError = {};
      state.machineAssignmentLocationSuccess = {};
      state.machineAssignmentLocationErrorMessage = {};
    })
    .addCase(machineAssignmentToLocationThunk.rejected, (state, action) => {
      state.machineAssignmentLocationLoading = {};
      state.machineAssignmentLocationError[action.meta.arg.location] = true;
      state.machineAssignmentLocationSuccess = {};
      state.machineAssignmentLocationErrorMessage[action.meta.arg.location] =
        action.payload?.message;
    })
    .addCase(machineAssignmentToLocationThunk.fulfilled, (state, action) => {
      state.machineAssignmentLocationLoading = {};
      state.machineAssignmentLocationError = {};
      state.machineAssignmentLocationSuccess[action.meta.arg.location] = true;
      state.machineAssignmentLocationErrorMessage = {};
      state.machines = state.machines.map((item) =>
        item.id === action.meta.arg.machine
          ? { ...item, location: action.payload.location_name }
          : item
      );
    });
};
